// extracted by mini-css-extract-plugin
export default {"wrap":"du-z","logoContainer":"eu-z","brandImg":"fu-z","logoImg":"gu-z","logoButton":"hu-z"};